import React from 'react';
import { ReactComponent as AIBtnIcon } from '@/images/icons/AIBtnIcon_sd.svg';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
const SuborbinateAIBtn = (props) => {
    const { text = '下属AI助手', handleClick, style = {} } = props || {};
    const [aiAssistSideBarEnable_sd] = useState2RM('aiAssistSideBarEnable_sd');
    return aiAssistSideBarEnable_sd ? (React.createElement("div", { onClick: () => {
            handleClick && handleClick();
        }, style: Object.assign(Object.assign({}, style), { height: '44px', display: 'inline-flex', padding: '11px 20px', justifyContent: 'center', alignItems: 'center', borderRadius: '8px', background: 'linear-gradient(97deg, #515AFF 1.51%, #8766FF 74.19%, #A866FF 98.42%)', gap: '6px', color: '#FFF', fontFamily: 'PingFang SC', fontSize: 14, fontStyle: 'normal', fontWeight: 400, cursor: 'pointer' }) },
        React.createElement(AIBtnIcon, null),
        React.createElement("span", null, text))) : null;
};
export default SuborbinateAIBtn;
